import { ApiType, tzDateTimeStringToUtc } from "@gymflow/common";
import {
  InvoiceType,
  RevenueReportDTO,
  RevenueReportItemDTO,
} from "@gymflow/types";
import { useQuery } from "@tanstack/react-query";

import { defaultPage } from "../defaultPage";
import { reportQueryKeys } from "./reportQueryKeys";

export interface UseRevenueBySaleTypeReportProps {
  api: ApiType;
  dateFrom?: string;
  dateTo?: string;
  limit: number;
  invoiceType?: InvoiceType;
  page: number;
  tz: string;
}

export function useRevenueBySaleTypeReport({
  api,
  limit,
  dateFrom,
  dateTo,
  page,
  invoiceType,
  tz,
}: UseRevenueBySaleTypeReportProps) {
  const result = useQuery({
    queryKey: [
      reportQueryKeys.revenueAccountsReceivable({
        page,
        limit,
        dateFrom,
        invoiceType,
        dateTo,
      }),
    ],
    queryFn: async () => {
      const resultRequest = api.revenueApi.find({
        page,
        limit,
        extraParams: {
          invoiceType,
          ...(dateFrom !== undefined
            ? { dateFrom: tzDateTimeStringToUtc(dateFrom, tz) }
            : {}),
          ...(dateTo !== undefined
            ? { dateTo: tzDateTimeStringToUtc(dateTo, tz) }
            : {}),
        },
      });
      const totalRequest = api.revenueApi.total({
        invoiceType,
        ...(dateFrom !== undefined
          ? { dateFrom: tzDateTimeStringToUtc(dateFrom, tz) }
          : {}),
        ...(dateTo !== undefined
          ? { dateTo: tzDateTimeStringToUtc(dateTo, tz) }
          : {}),
      });
      const [result, total] = await Promise.all([resultRequest, totalRequest]);
      return {
        data: result.data,
        total: total.data.total,
      } as RevenueReportDTO;
    },
    placeholderData: () => {
      return {
        data: defaultPage<RevenueReportItemDTO>(),
        total: 0,
      };
    },
    enabled: !!tz,
  });
  return result;
}
